<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnReservesAdditionSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Toevoeging egalisatiereserve')"
                         :calculated-value="data.calculated.eligible_reserves_addition_equalisation_reserve"
                         v-model="data.edit.eligible_reserves_addition_equalisation_reserve"/>

      <TaxReturnTableRow :description="$gettext('Toevoeging herinvesteringsreserve')"
                         :calculated-value="data.calculated.eligible_reserves_addition_reinvestment_reserve"
                         v-model="data.edit.eligible_reserves_addition_reinvestment_reserve"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>